import React from 'react'
import { Drawer, Box, Typography, IconButton, List } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { ResumeListItem } from './ResumeListItem'
import { NavigationListItems } from './NavigationListItems'

interface NavigationItem {
    key: string
    path: string
    label: string
    isResume?: boolean
}

interface MobileDrawerProps {
    open: boolean
    onClose: () => void
    user: { id: string } | null
    navigationItems: NavigationItem[]
    authItems: NavigationItem[]
    isActive: (path: string) => boolean
    isLessonPage: () => boolean
    onNavigation: (path: string) => void
    onResumeClick: () => void
    onLogout: () => void
    mostRecentStory: { storyId: string; storyTitle: string } | null
    progressLoading: boolean
    isLlmLocked?: boolean
}

export const MobileDrawer: React.FC<MobileDrawerProps> = ({
    open,
    onClose,
    user,
    navigationItems,
    authItems,
    isActive,
    isLessonPage,
    onNavigation,
    onResumeClick,
    onLogout,
    mostRecentStory,
    progressLoading,
    isLlmLocked = false,
}) => {
    const { t } = useTranslation()

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            sx={{
                '& .MuiDrawer-paper': {
                    width: (theme) => theme.spacing(35), // 280px = 35 * 8px
                },
            }}
        >
            <Box sx={{ p: 2 }}>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        mb: 2,
                    }}
                >
                    <Typography variant="h6" component="div">
                        {t('navigation:menu')}
                    </Typography>
                    <IconButton onClick={onClose} aria-label={t('navigation:closeMenu')}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <List>
                    {user ? (
                        <>
                            {navigationItems.map((item) => {
                                if (item.isResume) {
                                    return (
                                        <ResumeListItem
                                            key={item.key}
                                            item={item}
                                            mostRecentStory={mostRecentStory}
                                            progressLoading={progressLoading}
                                            isLessonPage={isLessonPage}
                                            onResumeClick={onResumeClick}
                                            llmLocked={isLlmLocked}
                                        />
                                    )
                                }
                                return null
                            })}
                            <NavigationListItems
                                user={user}
                                navigationItems={navigationItems.filter((item) => !item.isResume)}
                                authItems={authItems}
                                isActive={isActive}
                                onNavigation={(path) => {
                                    onNavigation(path)
                                    onClose()
                                }}
                                onLogout={onLogout}
                            />
                        </>
                    ) : (
                        <NavigationListItems
                            user={user}
                            navigationItems={navigationItems}
                            authItems={authItems}
                            isActive={isActive}
                            onNavigation={onNavigation}
                            onLogout={onLogout}
                        />
                    )}
                </List>
            </Box>
        </Drawer>
    )
}
